@if (!loaded) {
  <div class="loading">
    <div>
      <div>Bezig met laden ...</div>
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
}

@if (loaded) {
  <mat-sidenav-container class="all-wrap" fullscreen>
    <mat-sidenav [mode]="menuMode" [opened]="isMenuOpen" #sidenav class="mat-elevation-z5 uf-sidenav">
      <mat-toolbar color="primary">
        Menu
      </mat-toolbar>
      <mat-list>
        <mat-list-item class="menu-item-dashboard" routerLinkActive="active" [routerLink]="['/dashboard']" (click)="onMenuItemClick()">Dashboard</mat-list-item>
        <mat-divider *ngxPermissionsOnly="[permissions.PURCHASES]"></mat-divider>
        <mat-list-item class="menu-item-purchases" routerLinkActive="active" [routerLink]="['/purchases']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.PURCHASES]">Inkopen
        </mat-list-item>
        <mat-divider *ngxPermissionsOnly="[permissions.OFFER_LEADS]"></mat-divider>
        <mat-list-item class="menu-item-users" routerLinkActive="active" [routerLink]="['/quotations/lead']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.OFFER_LEADS]">Potentiële klanten
        </mat-list-item>
        <mat-list-item class="menu-item-offerquotation" routerLinkActive="active" [routerLink]="['/quotations']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.OFFER_QUOTATION]">Offertes
        </mat-list-item>
        <mat-divider *ngxPermissionsOnly="[permissions.INVOICES]"></mat-divider>
        <mat-list-item class="menu-item-invoices" routerLinkActive="active" [routerLink]="['/invoices']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.INVOICES]">Verkopen
        </mat-list-item>
        <mat-list-item class="menu-item-contracts" routerLinkActive="active" [routerLink]="['/contracts']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.CONTRACTS]">Contracten
        </mat-list-item>
        <mat-list-item class="menu-item-stock" routerLinkActive="active" [routerLink]="['/stock/vehicles']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.STOCK]">Voorraad
        </mat-list-item>
        <mat-list-item class="menu-item-stockgroups" routerLinkActive="active" [routerLink]="['/stock/vehicle-groups']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.STOCK]">Voorraad groepen
        </mat-list-item>
        <mat-list-item class="menu-item-payments" routerLinkActive="active" [routerLink]="['/payments']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.REMINDER]">Betalingen
        </mat-list-item>
        <mat-divider *ngxPermissionsOnly="[permissions.RELATIONS]"></mat-divider>
        <mat-divider *ngxPermissionsOnly="[permissions.RELATIONS]"></mat-divider>
        <mat-list-item class="menu-item-relations" routerLinkActive="active" [routerLink]="['/relations']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.RELATIONS]">Relaties
        </mat-list-item>
        <mat-list-item class="menu-item-relationgroups" routerLinkActive="active" [routerLink]="['/relationgroups']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.RELATIONS]">Relatie groepen
        </mat-list-item>
        <mat-list-item class="menu-item-articles" routerLinkActive="active" [routerLink]="['/articles']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.ARTICLES]">Artikelen
        </mat-list-item>
        <mat-list-item class="menu-item-vehicles" routerLinkActive="active" [routerLink]="['/vehicles']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.VEHICLES]">Voertuigen
        </mat-list-item>
        <mat-divider *ngxPermissionsOnly="[permissions.WORK_ORDERS]"></mat-divider>
        <mat-list-item class="menu-item-workorders" routerLinkActive="active" [routerLink]="['/work-orders']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.WORK_ORDERS]">Werkorders
        </mat-list-item>
        <mat-list-item class="menu-item-relation-devices" routerLinkActive="active" [routerLink]="['/relation-devices']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.RELATIONDEVICES]">Klantinstallaties
        </mat-list-item>
        <mat-list-item class="menu-item-administrations" routerLinkActive="active" [routerLink]="['/admin/administrations']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.ADMINISTRATIONS]">Administraties
        </mat-list-item>
        <mat-list-item class="menu-item-users" routerLinkActive="active" [routerLink]="['/admin/users']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.USERS]">Gebruikers
        </mat-list-item>
        <mat-divider *ngxPermissionsOnly="[permissions.VEHICLES]"></mat-divider>
        <mat-list-item class="menu-item-reports" routerLinkActive="active" [routerLink]="['/reports']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.VEHICLES]">Rapportages
        </mat-list-item>
        <mat-list-item class="menu-item-reports" routerLinkActive="active" [routerLink]="['/finance-report']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.FINANCEREPORT]">Financieel
        </mat-list-item>
        <mat-divider *ngxPermissionsOnly="[permissions.SETTINGS]"></mat-divider>
        <mat-list-item class="menu-item-settings" routerLinkActive="active" [routerLink]="['/settings']" (click)="onMenuItemClick()"
          *ngxPermissionsOnly="[permissions.SETTINGS]">
          Instellingen <mat-icon svgIcon="cog" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>
        </mat-list-item>
      </mat-list>
    </mat-sidenav>
    <div class="page-wrap">
      <header role="banner">
        <mat-toolbar color="primary" class="uf-topbar">
          <button mat-icon-button type="button" (click)="sidenav.toggle()" title="Open sidenav">
            <mat-icon svgIcon="menu"></mat-icon>
          </button>
          {{title}}
          <div class="filler"></div>
          <uf-select-administration [administrations]="administrations" [administration]="administration" (administrationChange)="selectAdministration($event)"></uf-select-administration>
          <button mat-button [matMenuTriggerFor]="appMenu">
            <mat-icon class="p-r-8" svgIcon="account-circle"></mat-icon>
            {{firstName}} {{lastName}}
          </button>
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="myAccount()">Mijn account</button>
            <button mat-menu-item (click)="onLogout()">Uitloggen</button>
          </mat-menu>
        </mat-toolbar>
      </header>
      <main class="content">
        <router-outlet></router-outlet>
      </main>
      <footer class="footer-version">
        <div>{{version}}</div>
      </footer>
    </div>
  </mat-sidenav-container>
}
